import { Box, TextField } from "@mui/material";
import ViemoPlayerWithMarker from "./ViemoPlayerWithMarker";
import MultiSelectDropdownWithImages from "../CreateUpdateEntertainmentEntity/MultiSelectDropdownWithImages";
import { updateStateObjectData } from "../../../utility/Common";
import { GameCssStyles } from "../../GameManagement/GameCssStyles";

const TabContainorMultimedia = ({ editableMultimediaData, setEditableMultimediaData, multimediaData, setMultimediaData, artists, showLoader, global_constant }) => {
    //console.log("TabContainorMultimedia - editableMultimediaData : ", editableMultimediaData);
    console.log("TabContainorMultimedia - multimediaData : ", multimediaData);
    //console.log("TabContainorMultimedia - artists : ", artists);
    return (
        <Box sx={styles.containerStyleRow_sx}>

            <ViemoPlayerWithMarker editableMultimediaData={editableMultimediaData} setEditableMultimediaData={setEditableMultimediaData} multimediaData={multimediaData} setMultimediaData={setMultimediaData} global_constant={global_constant} />

            <TextField
                fullWidth
                label="URL"
                value={multimediaData?.url}
                InputProps={{ readOnly: true }}
                sx={[{ ...GameCssStyles.formSingleLineTextField_sx }, { mt: 2 }]}
            />

            {/* <MultiSelectDropdownWithImages
                value={
                    Array.isArray(multimediaData?.entity)
                        ? multimediaData.entity
                            .map(entity => artists?.find(artist => artist?._id === entity?.id))
                            .filter(Boolean)
                        : []
                }
                artists={Array.isArray(artists) ? artists : []}
                onChange={(event, newValue) => {
                    const selectedIds = Array.isArray(newValue)
                        ? newValue.map(item => ({
                            id: item?._id,
                            type: item?.type || ""
                        }))
                        : [];

                    updateStateObjectData(
                        multimediaData,
                        setMultimediaData,
                        'entity',
                        selectedIds
                    );
                }} /> */}

            {/* <EntityEssentialInfo editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} global_constant={global_constant} createQuestions={createQuestions} />
            <EntityMetadataAccordingToType editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} artists={artists} global_constant={global_constant} />
            <EntityTags editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} editableEntityTagsData={editableEntityData?.tags} geners_type={global_constant?.tags} /> */}
        </Box>
    );
}

const styles = {
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'flex-start',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 4,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4,
        height: "100%",
        alignItems: "center",
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

export default TabContainorMultimedia;